import { Injectable, ElementRef } from '@angular/core';

@Injectable()
export class MeasureService {

  constructor() { }

  /**
   * @description creates a new EsriMeasureWidget for Distance or Area
   * @param view mapview to take new measures
   * @param activeWidget Reference of the widget to create.
   * @param measureRef Reference of the element to add the widget to
   */
  public createMeasureWidget(
    view: __esri.MapView,
    activeWidget: __esri.DistanceMeasurement2D | __esri.AreaMeasurement2D,
    measureRef: ElementRef
  ) {
    const containerToAddMeasure: HTMLDivElement = this.createMeasureDiv();
    measureRef.nativeElement.appendChild(containerToAddMeasure);
    const widgetProperties = this.widgetProperties(view, containerToAddMeasure);
    activeWidget.set(widgetProperties);
    activeWidget.viewModel.start();
  }

  /**
   * @description returns a map of widget-properties for the measurement tool
   * @param view mapview to take new measures
   * @param container DOM Element to add the measurewidget to
   */
  private widgetProperties(view: __esri.MapView, container: HTMLDivElement): HashMap<any> {
    return {
      view: view,
      container: container,
      unit: 'metric',
      unitOptions: ['metric', 'kilometers', 'meters']
    };
  }

  /**
   * @description creates a div to add the widget to
   */
  private createMeasureDiv(): HTMLDivElement {
    const measureDiv: HTMLDivElement = document.createElement('div');
    measureDiv.setAttribute('id', 'measure');
    return measureDiv;
  }
}
